import { render, staticRenderFns } from "./SignupDialog.vue?vue&type=template&id=7bddd6cb&"
import script from "./SignupDialog.vue?vue&type=script&lang=js&"
export * from "./SignupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports